// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"7ae187c0","990":"51134c3a"}[chunkId] + ".chunk.js";
};